<template>
    <button :class="btnClass" @click.prevent="eventHandle(page)" :title="tooltip">
        <font-awesome-icon v-if="icon" :icon="icon" size="lg" class="link-icon" />
        <span v-if="props?.title">
            {{ props?.title }}
        </span>

    </button>
</template>

<script setup>
import { defineEmits, defineProps } from 'vue';

const emits = defineEmits(['default']);
const props = defineProps({
    title: String,
    color: String,
    icon: String,
    tooltip: String,
    btnClass: String
});


const eventHandle = () => {
    emits('default');
};
</script>